type MonthSpanResult =
  | { ok: true; months: 1 | 2 | 3 | 4 }
  | { ok: false; reason: 'START_NOT_FIRST_DAY' | 'END_NOT_LAST_DAY' | 'OUT_OF_RANGE' | 'END_BEFORE_START' }

/**
 * Rules:
 * - start date must be day 1 of its month
 * - end date must be the last day of its month (handles Feb/leap years etc.)
 * - months are counted inclusively:
 *   diffMonths = (endYM - startYM)
 *   months = diffMonths + 1
 * Examples:
 * - 2024-07-01 .. 2024-07-31 => diff 0 => months 1
 * - 2024-07-01 .. 2024-08-31 => diff 1 => months 2
 */
export function getInclusiveMonthSpan1to4(
  start: Date,
  end: Date,
): MonthSpanResult {
  const s = new Date(start.getTime())
  const e = new Date(end.getTime())

  if (e.getTime() < s.getTime()) {
    return { ok: false, reason: 'END_BEFORE_START' }
  }

  const sDay = s.getDate()
  const sMonth = s.getMonth() // 0-11
  const sYear = s.getFullYear()

  const eDay = e.getDate()
  const eMonth = e.getMonth()
  const eYear = e.getFullYear()

  if (sDay !== 1) return { ok: false, reason: 'START_NOT_FIRST_DAY' }

  const lastDayOfEndMonth = getLastDayOfMonth(eYear, eMonth)
  if (eDay !== lastDayOfEndMonth) return { ok: false, reason: 'END_NOT_LAST_DAY' }

  const sIndex = sYear * 12 + sMonth
  const eIndex = eYear * 12 + eMonth

  const diff = eIndex - sIndex // 0 => same month
  const months = diff + 1 // inclusive month count

  if (months < 1 || months > 4) return { ok: false, reason: 'OUT_OF_RANGE' }

  return { ok: true, months: months as 1 | 2 | 3 | 4 }
}

/** month is 0-11 */
function getLastDayOfMonth(year: number, month: number): number {
  // Day 0 of next month = last day of current month
  return new Date(year, month + 1, 0).getDate()
}
